/**
 * Electron Notification Adapter
 * Uses Electron's native Notification API via IPC
 */

import type { NotificationAdapter } from './notification.adapter';

export class ElectronNotificationAdapter implements NotificationAdapter {
  isSupported(): boolean {
    return true; // Electron always supports native notifications
  }

  async requestPermission(): Promise<boolean> {
    return true; // Electron notifications don't require web permission
  }

  async subscribe(): Promise<boolean> {
    // Electron gets notifications via Socket.IO → IPC, not push subscription
    // No server-side subscription needed
    return true;
  }

  async unsubscribe(): Promise<boolean> {
    return true;
  }

  async isSubscribed(): Promise<boolean> {
    return true; // Always "subscribed" since we use Socket.IO
  }

  async show(title: string, body: string, url?: string): Promise<boolean> {
    if (!window.electronAPI) return false;

    try {
      return await window.electronAPI.invoke('notification:show', {
        title,
        body,
        url,
      }) as boolean;
    } catch {
      return false;
    }
  }
}
